import { render, staticRenderFns } from "./pricerecord.vue?vue&type=template&id=2c70d210&scoped=true"
import script from "./pricerecord.vue?vue&type=script&lang=js"
export * from "./pricerecord.vue?vue&type=script&lang=js"
import style0 from "./pricerecord.vue?vue&type=style&index=0&id=2c70d210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70d210",
  null
  
)

export default component.exports